export default "__VITE_ASSET__jRimste4ipH0DaZTvduH8w__"